(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const messageType = document.getElementById('contact-message-type');
  const guaranteeField = document.querySelector('.contact-form__guarantee-field');
  const examDate = document.getElementById('contact-official-exam-date');

  if (messageType && guaranteeField && examDate) {
    const toggleGuaranteeField = () => {
      const isGuaranteeClaim = messageType.value === 'Peerless Money Back Guarantee claim';
      guaranteeField.hidden = !isGuaranteeClaim;
      examDate.required = isGuaranteeClaim;
    };

    messageType.addEventListener('change', toggleGuaranteeField);
    toggleGuaranteeField();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["practice-test-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var input = document.querySelector('[data-ptl-search]');
    var grid  = document.querySelector('[data-ptl-grid]');
    var empty = document.querySelector('[data-ptl-empty]');
    if (!input || !grid) return;

    var cards = Array.from(grid.querySelectorAll('.ptl-card'));

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var match = !q || (card.dataset.name || '').indexOf(q) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      if (empty) empty.style.display = visible === 0 ? 'block' : 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["practice-test-picker"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-picker]').forEach(function (picker) {
    var select = picker.querySelector('[data-picker-select]');
    var go = picker.querySelector('[data-picker-go]');
    function navigate() {
      if (select && select.value) window.location.href = select.value;
    }
    if (go) go.addEventListener('click', navigate);
    if (select) select.addEventListener('keydown', function (e) { if (e.key === 'Enter') navigate(); });
  });

  /* POPUP DISABLED — remove the surrounding block comment to re-enable
  (function () {
    var storageKey = 'ptq_modal_seen';
    if (sessionStorage.getItem(storageKey)) return;

    var overlay = document.querySelector('[data-ptq-modal]');
    if (!overlay) return;

    var sel = overlay.querySelector('[data-modal-select]');
    var go  = overlay.querySelector('[data-modal-go]');

    function closeModal() {
      overlay.hidden = true;
      sessionStorage.setItem(storageKey, '1');
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    overlay.querySelectorAll('[data-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });
    if (go) go.addEventListener('click', function () {
      if (sel && sel.value) { closeModal(); window.location.href = sel.value; }
    });

    setTimeout(function () {
      overlay.hidden = false;
    }, 2000);
  })();
  */

  } catch(e) { console.error(e); }
})();
})();
